import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";
import { PreviewProduitComponent } from "src/app/shared/components/preview-produit/preview-produit.component";



@Component({
  selector: 'app-new-acte-bareme-statut',
  templateUrl: './new-acte-bareme-statut.component.html',
  styleUrls: ['./new-acte-bareme-statut.component.scss']
})
export class NewActeBaremeStatutComponent implements OnInit {

  listItems: Array<any> = [];
  @Input("currentBareme") currentBareme: any;
  @Input("currentProduitBareme") currentProduitBareme: any;
  @Input("itemsToAtoComponent") itemsToAtoComponent: any;
  @Input("statusToLoad") statusToLoad: any;
  @Output() onReloadGaranties = new EventEmitter<any>();
  @Output() onHideFormEvent = new EventEmitter<any>();
  isAllChecked = false;
  statut_to_copy_id: any;
  searchTerm: string = '';
  filteredItems: any;
  items: Array<any> = [];
  itemToSave: any = {};
  itemsUnselectedStatut: any = [];
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  selectedGarantieProduitBareme: any = {}
  currentPage: number = 0;
  itemsPerPage: number = 20;
  totalItems: number;
  currentActeBaremeStatut: any = {}

  itemToSearchGarantie: any = {};
  totalItemsGarantie: number;
  itemsTypeMajoration: any = [
    { value: "forfait", libelle: "Forfait" },
    { value: "taux", libelle: "Taux" },
  ];

  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "acteBaremeStatut";
  title: string = "Acte statut";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsModeTarification: any = [];
  itemsModeFractionnement: any = [];
  gender = "F";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeAssurance: any[];
  itemsModeReconduction: any;
  isTarificationFamille: any;
  bsModalRefPreview: BsModalRef;
  itemsGarant: any;
  itemsGarantProduit: any;
  indiceTab: number = 0;
  itemsFamilleGarantie: any;
  totalItemsFamilleGarantie: any;
  itemsGarantie: any = [];
  activeRow: any = {};
  itemsStatut: any;
  selected_produit: any;
  itemsTrancheAge: any;
  totalItemsFamilleGarantieStatut: any;
  selectedActe: any = {}

  autorizationOptions: any = [
    { value: 1, libelle: "Oui" },
    { value: 0, libelle: "Non" },
  ];
  currentActeBaremeStatutStatut: any;
  itemsJourAutoriseOriginalList: any[];
  itemsJourAutoriseToSave: any = [];
  itemsJourAutorise: any;
  itemsGarantieConfigured: any = [];
  default_data_id: any = [];
  isDataToCopy: boolean;
  itemsTypeRemboursement: any;

  modalRefDynamicPlafondTransacton: BsModalRef;
  itemsPeriodicite: any = [];
  itemToAdd: any = {};
  itemsPlafondTransaction: any = [];
  garantieRow: any = {}


  itemsReseauDeSoin: any;
  itemsDays: any = [
    {
      code: 1, libelle: 'Lundi'
    },
    {
      code: 2, libelle: 'Mardi'
    },
    {
      code: 3, libelle: 'Mercredi'
    },
    {
      code: 4, libelle: 'Jeudi'
    },
    {
      code: 5, libelle: 'Vendredi'
    },
    {
      code: 6, libelle: 'Samedi'
    },
    {
      code: 7, libelle: 'Dimanche'
    },
  ];

  modalRefRseauSoinIntervalle: BsModalRef;
  itemsReseauIntervalle: any = [];
  itemToAddReseauIntervalle: any = {};
  itemsGarantieProduitBareme: any = [];
  itemsActe: any = [];
  itemsActeBareme: any = [];

  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.deleteMessage =
      "Vous êtes sur le point de supprimer " + text1 + " " + this.title;

    setTimeout(() => {
      // this.getItemsGenre()
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges) { }

  pageChanged(event: any): void {
    this.currentPage = event.page - 1;
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }

  onAddItemToList() {
    if (this.selectedActe && this.selectedActe.id) {
      this.selectedActe.bareme_id = this.currentBareme.id
      this.selectedActe.acte_id = this.selectedActe.id
      this.selectedActe.statut_id = this.itemToSave.statut_id
      this.itemsActeBareme.unshift(this.selectedActe)
      this.selectedActe = {}
    }
  }

  confirmSaveItem(item) {
    console.info("item: ", item);
    console.info("currentActeBaremeStatut: ", this.currentActeBaremeStatut);

    // item.specialiteId = this.selectedSpecialite.id
    // if (!item || !item.libelle) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner libellé !",fv
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (!item || !item.code) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner code !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (!item || !item.type_assurance) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner type !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (!item || !item.franchise) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner franchise !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    // if (!item || !item.plafond_annuel) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner boite plafond annuel !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (!item || !item.prime_base) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner compte prime de base !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (!item || !item.description) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner description !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if(!item.id && !item.code)
    //   item.code = this.generateUniqueString()

    //   if(item.id){
    //     delete item.produit
    //     delete item.filiale
    //     delete item.garant
    //   }

    let objToSave = Object.assign({}, item);

    Object.keys(this.currentActeBaremeStatut).forEach(key => {
      if (!(key in objToSave)) {
        objToSave[key] = this.currentActeBaremeStatut[key];
      }
    });

    console.info("objToSavexxx: ", objToSave);

    Swal.fire({
      title: this.capitalize(this.title),
      text: this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        // ;
        this.saveItem(objToSave);
      }
    });
  }

  confirmSaveItemsJourAutorise() {
    let contains_invalid_item = false;
    for (let i = 0; i < this.itemsJourAutoriseToSave.length; i++) {
      const element = this.itemsJourAutoriseToSave[i];
      if (element.heure_debut > element.heure_fin) {
        contains_invalid_item = true;
        break;
      }
    }

    if (contains_invalid_item) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Heure debut doit etre inférieur à heure de fin !",
        "bottom",
        "center"
      );
      return;
    }

    Swal.fire({
      title: "Sauvegarder",
      text: this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        // ;
        this.saveItemJourAutorises();
      }
    });
  }

  saveItemJourAutorises() {
    let itemAEnregistrer = [];
    this.itemsJourAutoriseToSave.map((iae) => {
      itemAEnregistrer.push({
        jour_autorise_id: iae.id,
        garantie_bareme_statut_id: this.currentActeBaremeStatutStatut.id,
        heure_debut: iae.heure_debut,
        heure_fin: iae.heure_fin,
        statut_id: this.currentActeBaremeStatutStatut.statut_id,
        is_checked: iae.is_checked,
        filiale_id: this.user.filiale_id,
      });
    });

    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: itemAEnregistrer,
    };

    this.busySave = this.restClient
      .post("jourAutoriseGarantieBaremeStatut/create", request)
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.modalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  getItemsGenre() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("genre/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGenre = _.orderBy(res["items"], ["libelle"], ["asc"]);
            // this.getItems();
          } else {
            this.itemsGenre = [];
          }
        },
        (err) => {
          this.itemsGenre = [];
        }
      );
  }

  saveItem(item) {
    console.log('item to save: ',item)
    if (item.lundi_start && item.lundi_end) {
      item.horaire_lundi = item.lundi_start + ';' + item.lundi_end
    }
    if (item.mardi_start && item.mardi_end) {
      item.horaire_mardi = item.mardi_start + ';' + item.mardi_end
    }
    if (item.mercredi_start && item.mercredi_end) {
      item.horaire_mercredi = item.mercredi_start + ';' + item.mercredi_end
    }
    if (item.jeudi_start && item.jeudi_end) {
      item.horaire_jeudi = item.jeudi_start + ';' + item.jeudi_end
    }
    if (item.vendredi_start && item.vendredi_end) {
      item.horaire_vendredi = item.vendredi_start + ';' + item.vendredi_end
    }
    if (item.samedi_start && item.samedi_end) {
      item.horaire_samedi = item.samedi_start + ';' + item.samedi_end
    }
    if (item.dimanche_start && item.dimanche_end) {
      item.horaire_dimanche = item.dimanche_start + ';' + item.dimanche_end
    }

    delete item.garantie
    delete item.acte

    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [item],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + (item.is_old ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.currentPage = 0;
            this.statut_to_copy_id = "";
            // this.getItems()
            this.getItemsActeBaremeStatut();

            // this.modalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  setUnselectedStatutList() {
    this.itemsUnselectedStatut = this.itemsStatut.filter(
      (is) => is.id != this.itemToSave.statut_id
    );
    console.log("this.itemsUnselectedStatut: ", this.itemsUnselectedStatut);
  }
  getItemsActeBaremeStatut() {
    console.log('this.currentBareme: ', this.currentBareme)
    if (!this.itemToSave.garantie_id) return
    if (!this.currentBareme.id) return
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      order_by: "-created_at",
      data: { 
        bareme_id: this.currentBareme.id,
        garantie_id: this.itemToSave.garantie_id, 
        acte_id: this.selectedActe?this.selectedActe.id:null
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("acteBaremeStatut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.itemsActeBareme = res["items"].map((it: any) => {
              it.is_old = true;
              it.date_effet = moment(it.date_effet).toDate();
              return this.setHoraireStartEnd(it);
            });

            console.log("Transformed items:", this.itemsActeBareme);
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsActeBareme = [];
          }

          this.filteredItems = [...this.itemsActeBareme];
        },
        (err) => {
          this.itemsActeBareme = [];
        }
      );
  }

  getItemsGarantieProduitBaremeBareme() {

    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      order_by: "libelle",
      data: {
        produit_bareme_id: this.currentProduitBareme.id,
        bareme_id: this.currentBareme.id,
      },
      index: 0,
      size: 1000,
    };

    this.busyGet = this.restClient
      .post("garantieProduitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.itemsGarantieProduitBareme = res["items"];
            // this.items.sort((a, b) => this.customSortGarantie(a, b))
            // this.totalItems = res["count"];
            // this.currentPage = 0;
            // console.log('items before getItemsActeBaremeStatut',this.items)
            // this.filteredItems = [...this.items]
            // this.filterList()

            // this.getItemsActeBaremeStatut();
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            // this.totalItems = 0;
            this.itemsGarantieProduitBareme = [];
            // this.reloadData()
            // this.fillForm()
          }
        },
        (err) => {
          this.itemsGarantieProduitBareme = [];
          // this.fillForm()
        }
      );
  }

  getItemsTrancheAge() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id: this.currentBareme.garant_id,
      },
    };

    this.busyGet = this.restClient
      .post("trancheAge/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTrancheAge = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsTrancheAge = [];
          }
        },
        (err) => {
          this.itemsTrancheAge = [];
        }
      );
  }
  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = res["items"];
            this.itemsStatut.sort((a, b) => this.customSort(a, b));
            this.itemToSave.statut_id = this.itemsStatut[0].id;
            this.setUnselectedStatutList();
            // this.getItems();
            this.getItemsActeBaremeStatut();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }

  onSelectDate(event) {
    if (event) {
      (this.dateNais = moment(event).format("DD/MM/YYYY")),
        console.info("dateNais", this.dateNais);
    }
  }

  changePaginationSize($event) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
  }

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  checkIfisTarificationFamille() {
    console.log("change");
    this.isTarificationFamille = false;
    if (this.itemsModeTarification && this.itemsModeTarification.length) {
      this.isTarificationFamille = !!this.itemsModeTarification.filter(
        (item) =>
          item.id == this.itemToSave.mode_tarification && item.code == "FAMILLE"
      ).length;
    }
  }

  openPreviewModal(url) {
    this.bsModalRefPreview = this.modalService.show(PreviewProduitComponent, {
      animated: true,
      keyboard: false,
      backdrop: "static",
      ignoreBackdropClick: true,
      class: "gray modal-lg modal-width-65 modal-custom",
    });
    this.bsModalRefPreview.content.currentLink = url;
  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  onCheckboxChange(event: Event, item: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
    }
  }

  addRowToList(item) {
    if (!this.isAddedToList(item)) {
      item.ticket_moderateur = 100 - this.currentProduitBareme.taux_couverture;
      // item.famille_garantie_id = item.id;
      this.items.push(item);
    }
  }

  isAddedToList(item) {
    if (this.items && this.items.length) {
      return !!this.items.filter((ifgb) => ifgb.famille_garantie_id == item.id)
        .length;
    }
    return false;
  }
  onCheckUncheckAll(event) {
    this.items.map((ifgb) => (ifgb.is_checked = event.target.checked));
  }

  checkIfAllChecked() {
    this.isAllChecked = this.items.every((ifgb) => ifgb.is_checked);
  }

  reloadData() {
    console.log("relaod with: ", this.items);
    let datasLineThrought = this.items;
    this.onReloadGaranties.emit(datasLineThrought);
  }

  openModal(data: any, template: TemplateRef<any>) {
    this.itemsGarantProduit = [];
    this.garantieRow = data
    this.currentActeBaremeStatut = this.currentActeBaremeStatut.id?this.currentActeBaremeStatut:{ ...data }

    console.log("currentActeBaremeStatut: ",this.currentActeBaremeStatut)

    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-45",
    };
    console.log("data: ", data);

    // this.itemToSave = {};
    if (data) {
      this.currentActeBaremeStatutStatut = data
      // this.setHoraireStartEnd(data)
      console.log
    }

    this.modalRef = this.modalService.show(template, config);
  }

  onHideHoraireForm(item){
    console.log('after hide: ',this.currentActeBaremeStatut)
    this.currentActeBaremeStatut=item
  }

  openModalPlafond(data: any, template: TemplateRef<any>) {
    this.garantieRow = data
    this.currentActeBaremeStatut = { ...data }

    this.itemsGarantProduit = [];

    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-80",
    };
    console.log("data: ", data);

    // this.itemToSave = {};
    if (data) {
      this.currentActeBaremeStatutStatut = data
      // this.setHoraireStartEnd(data)
      console.log
    }

    this.modalRef = this.modalService.show(template, config);
  }
  openModalTransaction(data: any, template: TemplateRef<any>) {
    this.garantieRow = data
    this.currentActeBaremeStatut = { ...data }

    this.itemsGarantProduit = [];

    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-80",
    };
    console.log("data: ", data);

    // this.itemToSave = {};
    if (data) {
      this.currentActeBaremeStatutStatut = data
      // this.setHoraireStartEnd(data)
      console.log
    }

    this.modalRef = this.modalService.show(template, config);
  }

  setHoraireStartEnd(data) {
    let elt = { ...data };
    if (
      elt.horaire_lundi &&
      elt.horaire_lundi.length &&
      elt.horaire_lundi.split(";") &&
      elt.horaire_lundi.split(";").length
    ) {
      elt.lundi_start = elt.lundi_start ?? elt.horaire_lundi.split(";")[0];
      elt.lundi_end = elt.lundi_end ?? elt.horaire_lundi.split(";")[1];
    }
    if (
      elt.horaire_mardi &&
      elt.horaire_mardi.length &&
      elt.horaire_mardi.split(";") &&
      elt.horaire_mardi.split(";").length
    ) {
      elt.mardi_start = elt.horaire_mardi.split(";")[0];
      elt.mardi_end = elt.horaire_mardi.split(";")[1];
    }
    if (
      elt.horaire_mercredi &&
      elt.horaire_mercredi.length &&
      elt.horaire_mercredi.split(";") &&
      elt.horaire_mercredi.split(";").length
    ) {
      elt.mercredi_start = elt.horaire_mercredi.split(";")[0];
      elt.mercredi_end = elt.horaire_mercredi.split(";")[1];
    }
    if (
      elt.horaire_jeudi &&
      elt.horaire_jeudi.length &&
      elt.horaire_jeudi.split(";") &&
      elt.horaire_jeudi.split(";").length
    ) {
      elt.jeudi_start = elt.horaire_mercredi.split(";")[0];
      elt.jeudi_end = elt.horaire_mercredi.split(";")[1];
    }
    if (
      elt.horaire_vendred &&
      elt.horaire_vendred.length &&
      elt.horaire_vendred.split(";") &&
      elt.horaire_vendred.split(";").length
    ) {
      elt.vendred_start = elt.horaire_vendred.split(";")[0];
      elt.vendred_end = elt.horaire_vendred.split(";")[1];
    }
    if (
      elt.horaire_samedi &&
      elt.horaire_samedi.length &&
      elt.horaire_samedi.split(";") &&
      elt.horaire_samedi.split(";").length
    ) {
      elt.samedi_start = elt.horaire_samedi.split(";")[0];
      elt.samedi_end = elt.horaire_samedi.split(";")[1];
    }
    if (
      elt.horaire_dimanche &&
      elt.horaire_dimanche.length &&
      elt.horaire_dimanche.split(";") &&
      elt.horaire_dimanche.split(";").length
    ) {
      elt.dimanche_start = elt.horaire_dimanche.split(";")[0];
      elt.dimanche_end = elt.horaire_dimanche.split(";")[1];
    }


    return elt;
  }

  updateHoraire() {
    console.log("this.currentActeBaremeStatutStatut: ", this.currentActeBaremeStatutStatut)
    console.log('items transform updateHoraire: ', this.items)
    this.modalRef.hide()
  }
  getGarantieBaremeStatutJourAutorise(): Promise<any> {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      data: {
        garantie_bareme_statut_id: this.currentActeBaremeStatutStatut.id,
        // statut_id:this.currentActeBaremeStatutStatut.statut_id
      },
      index: 0,
      size: 10000,
    };

    return new Promise((resolve, reject) => {
      this.busyGet = this.restClient
        .post("jourAutoriseGarantieBaremeStatut/getByCriteria", request)
        .subscribe(
          (res: any) => {
            if (
              res &&
              res["items"] &&
              !res["hasError"] &&
              res["items"].length
            ) {
              // let copy = [...this.itemsJourAutorise]
              console.log('res["items"]: ', res["items"]);
              let copy = _.cloneDeep(this.itemsJourAutorise);
              copy.forEach((item2) => {
                const item1 = res["items"].find(
                  (item1) => item1.jour_autorise_id === item2.id
                );
                if (item1) {
                  item2.is_checked = item1.is_checked;
                  item2.heure_debut = item1.heure_debut;
                  item2.heure_fin = item1.heure_fin;
                }
              });
              console.log("resolving when full", copy);

              resolve(copy);
            } else {
              // console.log('resolving when empty',[...this.itemsJourAutorise])
              let copy_original = _.cloneDeep(this.itemsJourAutorise);
              console.log("copy_original: ", copy_original);
              resolve(copy_original);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getItemsJourAutorise() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("jourAutorise/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsJourAutorise = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
            this.itemsJourAutoriseOriginalList = [...this.itemsJourAutorise];
            console.log(
              "this.itemsJourAutoriseOriginalList: ",
              this.itemsJourAutoriseOriginalList
            );
            // this.getItems()
          } else {
            this.itemsJourAutorise = [];
            this.itemsJourAutoriseOriginalList = [];
          }
        },
        (err) => {
          this.itemsJourAutorise = [];
        }
      );
  }

  checkUncheckAllJourAutorise(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.itemsJourAutoriseToSave.map((ija) => {
      ija.is_checked = target.checked;
    });
  }

  confirmDeleteItem(item, indice) {
    if (item.isLocal) {
      this.items.splice(indice, 1);
      return;
    }

    Swal.fire({
      title: this.capitalize(this.title),
      text: this.deleteMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        // ;
        this.deleteItem(item);
      }
    });
  }

  deleteItem(obj) {
    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [obj],
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/delete", request)
      .subscribe(
        (res) => {
          console.info(res);
          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.currentPage = 0;
            this.getItemsActeBaremeStatut();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          console.info("Error occured", err);
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
        }
      );
  }

  // onAutoFillWithSelected() {
  //   console.log("statut_to_copy_id: ", this.statut_to_copy_id);
  //   this.getItemsActeBaremeStatut(this.statut_to_copy_id);
  // }

  customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }
  customSortGarantie(a, b) {
    const desiredOrder = ["CONS", "HOS", "PHARMA", "BIO", "IMA", "MAT", "OPT", "DEN", "AUX", "EXA", "TRA", "BILN", "AMP"];
    return desiredOrder.indexOf(a.codification) - desiredOrder.indexOf(b.codification);
  }

  fillWithDefauldValues() {
    this.items.map((it) => {
      if (!it.is_pc) {
        it.is_pc = 1;
      }
      if (!it.forfait) {
        it.forfait = 0;
      }
      if (!it.is_entente_prealable) {
        it.is_entente_prealable = 0;
      }
      if (!it.delai_carence) {
        it.delai_carence = 0;
      }
      if (!it.ticket_moderateur) {
        let taux_couverture: number = this.currentBareme.produit_bareme ? this.currentBareme.produit_bareme.taux_couverture : 0;
        it.ticket_moderateur = 100 - taux_couverture;
      }
      if (!it.plafond_global) {
        //recupérer dans le barème
        it.plafond_global = 50000000;
      }
      if (!it.plafond_transaction) {
        it.plafond_transaction = 50000000;
      }
      if (!it.plafond_famille) {
        it.plafond_famille = 50000000;
      }
      if (!it.plafond_famille_jour) {
        it.plafond_famille_jour = 50000000;
      }
      if (!it.plafond_famille_semaine) {
        it.plafond_famille_semaine = 50000000;
      }
      if (!it.plafond_famille_mois) {
        it.plafond_famille_mois = 50000000;
      }
      if (!it.plafond_famille_trimestre) {
        it.plafond_famille_trimestre = 50000000;
      }
      if (!it.plafond_famille_semestre) {
        it.plafond_famille_semestre = 50000000;
      }
      if (!it.plafond_famille_annee) {
        it.plafond_famille_annee = 50000000;
      }
      if (!it.plafond_individuel) {
        it.plafond_individuel = 50000000;
      }
      if (!it.plafond_individuel_jour) {
        it.plafond_individuel_jour = 50000000;
      }
      if (!it.plafond_individuel_semaine) {
        it.plafond_individuel_semaine = 50000000;
      }
      if (!it.plafond_individuel_mois) {
        it.plafond_individuel_mois = 50000000;
      }
      if (!it.plafond_individuel_trimestre) {
        it.plafond_individuel_trimestre = 50000000;
      }
      if (!it.plafond_individuel_semestre) {
        it.plafond_individuel_semestre = 50000000;
      }
      if (!it.plafond_individuel_annee) {
        it.plafond_individuel_annee = 50000000;
      }
      if (!it.seuil_alerte_conso) {
        //à configurer dans les paramètres système
        it.seuil_alerte_conso = 80;
      }
      if (!it.seuil_suspension_tiers_payant) {
        //à configurer dans les paramètres système
        it.seuil_suspension_tiers_payant = 95;
      }
      if (!it.nombre_transact_jour) {
        //à configurer dans les paramètres système
        it.nombre_transact_jour = 1000;
      }
      if (!it.nombre_transact_semaine) {
        //à configurer dans les paramètres système
        it.nombre_transact_semaine = 1000;
      }
      if (!it.nombre_transact_mois) {
        //à configurer dans les paramètres système
        it.nombre_transact_mois = 1000;
      }
      if (!it.nombre_transact_trimestre) {
        //à configurer dans les paramètres système
        it.nombre_transact_mois = 1000;
      }
      if (!it.nombre_transact_semestre) {
        //à configurer dans les paramètres système
        it.nombre_transact_semestre = 1000;
      }
      if (!it.nombre_transact_annee) {
        //à configurer dans les paramètres système
        it.nombre_transact_annee = 1000;
      }
      if (!it.nombre_transact_exercice) {
        //à configurer dans les paramètres système
        it.nombre_transact_exercice = 1000;
      }
      if (!it.nombre_transaction_famille) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille = 1000;
      }
      if (!it.nombre_transaction_famille_jour) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille_jour = 1000;
      }
      if (!it.nombre_transaction_famille_semaine) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille_semaine = 1000;
      }
      if (!it.nombre_transaction_famille_mois) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille_mois = 1000;
      }
      if (!it.nombre_transaction_famille_trimestre) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille_trimestre = 1000;
      }
      if (!it.nombre_transaction_famille_semestre) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille_semestre = 1000;
      }
      if (!it.nombre_transaction_famille_annee) {
        //à configurer dans les paramètres système
        it.nombre_transaction_famille_annee = 1000;
      }
      if (!it.nombre_transaction_individuel) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel = 1000;
      }
      if (!it.nombre_transaction_individuel_jour) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel_jour = 1000;
      }
      if (!it.nombre_transaction_individuel_semaine) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel_semaine = 1000;
      }
      if (!it.nombre_transaction_individuel_mois) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel_mois = 1000;
      }
      if (!it.nombre_transaction_individuel_trimestre) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel_trimestre = 1000;
      }
      if (!it.nombre_transaction_individuel_semestre) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel_semestre = 1000;
      }
      if (!it.nombre_transaction_individuel_annee) {
        //à configurer dans les paramètres système
        it.nombre_transaction_individuel_annee = 1000;
      }

      if (!it.type_remboursement_id) {
        //à configurer dans les paramètres système
        // it.type_remboursement_id = 'TPRD';

        if (this.itemsTypeRemboursement && this.itemsTypeRemboursement.length) {
          it.type_remboursement_id = this.itemsTypeRemboursement.filter(
            (ig) => ig.codification == "TPRD"
          )[0].id;
          // it.is_disabled_genre = true;
        }

      }

      if (!it.is_jour_ferie_allowed) {
        //à configurer dans les paramètres système
        it.is_jour_ferie_allowed = 1;
      }
      if (!it.type_majoration) {
        //à configurer dans les paramètres système
        it.type_majoration = "taux";
      }
      if (!it.valeur_majoration) {
        //à configurer dans les paramètres système
        it.valeur_majoration = 10;
      }
      // if(!it.tranche_age_id){
      //   if(this.itemsTrancheAge && this.itemsTrancheAge.length)
      //     it.tranche_age_id = this.itemsTrancheAge[0].id
      // }
      if (!it.age_min) {
        it.age_min = 0;
      }
      if (!it.age_max) {
        it.age_max = 70;
      }
      if (it.codification == "MAT") {
        if (this.itemsGenre && this.itemsGenre.length) {
          it.genre_id = this.itemsGenre.filter(
            (ig) => ig.codification == "F"
          )[0].id;
          it.is_disabled_genre = true;
        }
      }
    });
  }

  setHoraireWithNormalData() {
    if (this.items && this.items.length) {
      this.items.map(it => {
        if (!it.lundi_start) {
          it.lundi_start = '00:00'
        }
        if (!it.lundi_end) {
          it.lundi_end = '23:59'
        }
        if (!it.mardi_start) {
          it.mardi_start = '00:00'
        }
        if (!it.mardi_end) {
          it.mardi_end = '23:59'
        }
        if (!it.mercredi_start) {
          it.mercredi_start = '00:00'
        }
        if (!it.mercredi_end) {
          it.mercredi_end = '23:59'
        }
        if (!it.jeudi_start) {
          it.jeudi_start = '00:00'
        }
        if (!it.jeudi_end) {
          it.jeudi_end = '23:59'
        }
        if (!it.vendredi_start) {
          it.vendredi_start = '00:00'
        }
        if (!it.vendredi_end) {
          it.vendredi_end = '23:59'
        }
        if (!it.samedi_start) {
          it.samedi_start = '00:00'
        }
        if (!it.samedi_end) {
          it.samedi_end = '23:59'
        }
        if (!it.dimanche_start) {
          it.dimanche_start = '00:00'
        }
        if (!it.dimanche_end) {
          it.dimanche_end = '23:59'
        }
      })
    }
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );

            this.itemsTypeRemboursement.sort((a, b) => this.customSortTypeRembCodification(a, b));
            // this.defaultValues.type_remboursement_id = this.itemsTypeRemboursement.filter(itr=>itr.codification=='TPRD')[0].id
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];
        }
      );
  }

  customSortTypeRembCodification(a, b) {
    const desiredOrder = ["TPRD", "TP", "RD", "TPG"];
    return desiredOrder.indexOf(a.codification) - desiredOrder.indexOf(b.codification);
  }

  clearUpValues() { }

  onHideForm() {
    this.onHideFormEvent.emit('Fermer modal')
  }
  filterList() {
    console.log('searchTerm: ', this.searchTerm)
    if (!this.searchTerm.trim()) {
      this.filteredItems = [...this.items]; // Show all items if search is empty
    } else {
      // debugger
      const searchLower = this.searchTerm.toLowerCase();
      this.filteredItems = this.items.filter(item =>
        item.libelle.toLowerCase().includes(searchLower)
      );
    }
  }

  // updateItem(itemEdit) {
  //   // Find the index of the item in the original list
  //   const index = this.items.findIndex(item => item.id === itemEdit.id);
  //   if (index !== -1) {
  //     // Replace the entire object in the original list
  //     this.items[index] = { ...this.items[index], ...itemEdit };
  //   }

  //   // Reapply the filter to ensure the filtered list reflects the update
  //   this.filterList();
  // }




  openModalPlafondTransaction(data: any, template: TemplateRef<any>) {
    this.garantieRow = data
    this.itemsPlafondTransaction = [];

    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1676656767577,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-90",
    };
    if (data) {
      this.currentActeBaremeStatutStatut = data
      console.log("this.currentActeBaremeStatutStatut: ", this.currentActeBaremeStatutStatut)

    }
    this.getItemsPlafondTransaction()
    this.modalRefDynamicPlafondTransacton = this.modalService.show(template, config);
  }
  getItemsPeriodicite() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      order_by: 'nombre_jours',
      data: {},
    };

    this.busyGet = this.restClient
      .post("periodicite/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            // this.itemsPeriodicite = _.orderBy(res["items"], ["libelle"], ["asc"]);
            this.itemsPeriodicite = res["items"]
          } else {
            this.itemsPeriodicite = [];
          }
        },
        (err) => {
          this.itemsPeriodicite = [];
        }
      );
  }


  onAddToList() {

    if (!this.itemToAdd || !this.itemToAdd.periodicite_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez choisir la périodicité",
        "bottom",
        "center"
      );
      return

    }
    if (!this.itemToAdd || !this.itemToAdd.nombre_transaction) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez choisir renseigner le nombre de transactions",
        "bottom",
        "center"
      );
      return

    }
    if (!this.itemToAdd || !this.itemToAdd.plafond) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner le plafond",
        "bottom",
        "center"
      );
      return

    }

    // debugger
    if (this.itemsPlafondTransaction && this.itemsPlafondTransaction.length) {
      let isExist = !!this.itemsPlafondTransaction.filter((ipt: any) => ipt.periodicite_id == this.itemToAdd.periodicite_id).length
      if (isExist) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Cette périodicité existe dejà dans la liste",
          "bottom",
          "center"
        );

        return
      }
    }
    this.itemToAdd.acte_id = this.currentActeBaremeStatutStatut.acte_id
    this.itemToAdd.statut_id = this.currentActeBaremeStatutStatut.statut_id
    this.itemToAdd.bareme_id = this.currentActeBaremeStatutStatut.bareme_id
    this.itemToAdd.code = this.generateUniqueString()
    this.itemToAdd.tab = 'bareme_acte_statut'
    this.itemToAdd.periodicite_libelle = this.itemsPeriodicite.find((ip: any) => ip.id == this.itemToAdd.periodicite_id).libelle
    this.itemsPlafondTransaction.push(this.itemToAdd)
    this.itemToAdd = {}
  }

  savePlafondTransaction() {

    if (!this.itemsPlafondTransaction || !this.itemsPlafondTransaction.length) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner des données",
        "bottom",
        "center"
      );
      return

    }

    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      tab: 'bareme_acte_statut',
      datas: [...this.itemsPlafondTransaction],
    };

    this.busyGet = this.restClient
      .post("baremeTransactionPeriodicite/create", request)
      .subscribe(
        (res) => {
          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.modalRefDynamicPlafondTransacton.hide();

          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  getItemsPlafondTransaction() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        statut_id: this.currentActeBaremeStatutStatut.statut_id,
        acte_id: this.currentActeBaremeStatutStatut.acte_id,
        bareme_id: this.currentActeBaremeStatutStatut.bareme_id,
        tab: 'bareme_acte_statut'
      },
    };

    this.busyGet = this.restClient
      .post("baremeTransactionPeriodicite/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPlafondTransaction = res["items"].map((it: any) => {
              return {
                periodicite_id: it.periodicite_id,
                nombre_transaction: it.nombre_transaction,
                plafond: it.plafond,
                plafond_famille: it.plafond_famille,
                nombre_transaction_famille: it.nombre_transaction_famille,
                acte_id: it.acte_id,
                statut_id: it.statut_id,
                periodicite_libelle: it.periodicite_libelle,
                tab: it.tab
              }
            });
          } else {
            this.itemsPlafondTransaction = [];
          }
        },
        (err) => {
          this.itemsPlafondTransaction = [];
        }
      );
  }


  updateRow(item) {
    item.plafond = Number(item.plafond)
    item.plafond_famille = Number(item.plafond_famille)
    this.itemToAdd = { ...item }
  }



  // Gestion réseau de soin intervalle

  openModalReseauIntervalle(data: any, template: TemplateRef<any>) {
    this.garantieRow = data
    this.itemsReseauIntervalle = [];

    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 16766256767577,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-90",
    };
    if (data) {
      this.currentActeBaremeStatutStatut = data

      console.log("this.currentActeBaremeStatutStatut: ", this.currentActeBaremeStatutStatut)
    }
    this.getItemsReseauDeSoin()
    this.getItemsReseauIntervalle()
    this.modalRefRseauSoinIntervalle = this.modalService.show(template, config);
  }

  getItemsReseauDeSoin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {

      },
    };

    this.busyGet = this.restClient
      .post("reseauDeSoin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsReseauDeSoin = res["items"]
          } else {
            this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          this.itemsReseauDeSoin = [];
        }
      );
  }


  onAddToListReseauIntervalle() {

    if (!this.itemToAddReseauIntervalle || !this.itemToAddReseauIntervalle.jour) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner jour",
        "bottom",
        "center"
      );
      return

    }
    if (!this.itemToAddReseauIntervalle || !this.itemToAddReseauIntervalle.heure_debut) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez choisir renseigner heure debut",
        "bottom",
        "center"
      );
      return

    }
    if (!this.itemToAddReseauIntervalle || !this.itemToAddReseauIntervalle.heure_fin) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner heure fin",
        "bottom",
        "center"
      );
      return

    }
    if (!this.itemToAddReseauIntervalle || !this.itemToAddReseauIntervalle.reseau_de_soin_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner réseau de soin",
        "bottom",
        "center"
      );
      return

    }

    // debugger
    // if (this.itemsReseauIntervalle && this.itemsReseauIntervalle.length) {
    //   let isExist = !!this.itemsReseauIntervalle.filter((ipt: any) => ipt.periodicite_id == this.itemToAddReseauIntervalle.periodicite_id).length
    //   if (isExist) {
    //     this.utilities.showNotification(
    //       "snackbar-danger",
    //       "Cette périodicité existe dejà dans la liste",
    //       "bottom",
    //       "center"
    //     );

    //     return
    //   }
    // }
    this.itemToAddReseauIntervalle.acte_id = this.currentActeBaremeStatutStatut.acte_id
    this.itemToAddReseauIntervalle.statut_id = this.itemToSave.statut_id
    this.itemToAddReseauIntervalle.bareme_id = this.currentActeBaremeStatutStatut.bareme_id
    this.itemToAddReseauIntervalle.code = this.generateUniqueString()
    this.itemToAddReseauIntervalle.tab = 'bareme_acte_statut'
    this.itemToAddReseauIntervalle.jour_libelle = this.itemsDays.find((ip: any) => ip.code == this.itemToAddReseauIntervalle.jour).libelle
    this.itemToAddReseauIntervalle.reseau_de_soin_libelle = this.itemsReseauDeSoin.find((ip: any) => ip.id == this.itemToAddReseauIntervalle.reseau_de_soin_id).libelle
    this.itemsReseauIntervalle.push(this.itemToAddReseauIntervalle)
    this.itemToAddReseauIntervalle = {}
  }


  saveReseauIntervalle() {

    if (!this.itemsReseauIntervalle || !this.itemsReseauIntervalle.length) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner des données",
        "bottom",
        "center"
      );
      return

    }
    // debugger
    // this.itemsReseauIntervalle.statut_id = this.itemToSave.statut_id
    this.itemsReseauIntervalle.map((iri:any)=>iri.statut_id=this.itemToSave.statut_id)
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      tab: 'bareme_acte_statut',
      datas: [...this.itemsReseauIntervalle],
    };

    this.busyGet = this.restClient
      .post("baremeReseauSoinIntervalle/create", request)
      .subscribe(
        (res) => {
          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.modalRefRseauSoinIntervalle.hide();

          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  getItemsReseauIntervalle() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        statut_id: this.currentActeBaremeStatutStatut.statut_id,
        acte_id: this.currentActeBaremeStatutStatut.acte_id,
        bareme_id: this.currentActeBaremeStatutStatut.bareme_id,
        tab: 'bareme_acte_statut'
      },
    };

    this.busyGet = this.restClient
      .post("baremeReseauSoinIntervalle/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsReseauIntervalle = res["items"]
            if (this.itemsReseauIntervalle && this.itemsReseauIntervalle.length) {
              this.itemsReseauIntervalle.map((ri: any) => {
                console.log('ri: ', ri.jour)
                ri.jour_libelle = this.itemsDays.find((itd: any) => itd.code == ri.jour).libelle
              })
            }
          } else {
            this.itemsReseauIntervalle = [];
          }
        },
        (err) => {
          this.itemsReseauIntervalle = [];
        }
      );
  }


  updateRowReseauIntervalle(item) {
    this.itemToAddReseauIntervalle = { ...item }
  }

  getItemsActe() {
    this.itemsActe = []
    if (!this.itemToSave.garantie_id && !this.itemToSave.garantie_id) {
      console.log("garantie null");
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      order_by: "libelle",
      data: {
        garantie_id: this.itemToSave.garantie_id,
      },
      index: 0,
      size: 1000,
    };

    this.busyGet = this.restClient
      .post("acte/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.itemsActe = res["items"];
            console.log('this.itemsActexxxxxx: ', this.itemsActe)
            // this.totalItems = res["count"];
            // this.currentPage = 0;

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsActe = [];
          }
        },
        (err) => {
          this.itemsActe = [];
        }
      );
  }
  // getItemsActe(statut_id?) {
  //   this.itemsActe = []
  //   if (!this.itemToSave.garantie_id && !this.itemToSave.garantie_id) {
  //     console.log("garantie null");
  //     return;
  //   }
  //   let request = {
  //     user_id: this.user.id,
  //     filiale_id: this.filiale_id || this.user.filiale_id,
  //     search_key: this.searchKey,
  //     order_by: "libelle",
  //     data: {
  //       // produit_bareme_id: this.currentProduitBareme.id,
  //       garantie_id: this.itemToSave.garantie_id,
  //       bareme_id: this.currentBareme.id,
  //     },
  //     index: 0,
  //     size: 1000,
  //   };

  //   this.busyGet = this.restClient
  //     .post("acte/getActeEligibleByGarantie", request)
  //     // .post("garantieProduitBareme/getByCriteria", request)
  //     .subscribe(
  //       (res) => {
  //         if (res && res["items"] && !res["hasError"]) {
  //           this.itemsActe = res["items"];
  //           console.log('this.itemsActexxxxxx: ', this.itemsActe)
  //           this.totalItems = res["count"];
  //           this.currentPage = 0;

  //         } else {
  //           this.utilities.showNotification(
  //             "snackbar-danger",
  //             this.utilities.formatMsgServeur(res["status"]["message"]),
  //             "bottom",
  //             "center"
  //           );
  //           this.itemsActe = [];
  //         }
  //       },
  //       (err) => {
  //         this.itemsActe = [];
  //       }
  //     );
  // }


  ngOnInit() {
    this.currentPage = 0;
    this.resetForm();
    // this.getItemsStatut();
    this.getItemsTrancheAge();
    this.getItemsJourAutorise();
    this.getItemsGenre();
    this.getItemsTypeRemboursement()
    this.getItemsPeriodicite()
    this.getItemsStatut()
    this.getItemsGarantieProduitBaremeBareme()
    this.getItemsActeBaremeStatut()
  }

}
